import React from 'react';
import thunk from 'redux-thunk';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware, compose } from 'redux';

import rootReducer from '../reducers';

const reduxDevtoolsExtensionCompose = window?.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__?.({ trace: true, traceLimit: 25 });
const composeEnhancers = (process.env.IS_DEV_MODE && reduxDevtoolsExtensionCompose) || compose;
const enhancer = composeEnhancers(applyMiddleware(thunk));
const store = createStore(rootReducer, {}, enhancer);

const StoreProvider = ({ children }) => <Provider store={store}>{children}</Provider>;

StoreProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default StoreProvider;
